import React, { Suspense, useEffect, useRef, useState } from 'react';
import Head from 'next/head';
import LazyLoad, { forceCheck } from 'react-lazyload';
import ViewMore from '../../components/ViewMore';
import st from './index.module.scss';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';

const LocationLanding = props => {
  const [activeTab, setActiveTab] = useState(0);
  const [countryInfo, setCountryInfo] = useState({
    country: 'US',
    key: 1,
  });

  const positions = [
    {
      name: 'Motion Graphic Designer',
      price: ['$1000', '$5,850', '£2,833', 'A$8530', 'NZ$4450', '$3000', 'CA$5525'],
    },
    {
      name: 'Graphic Designer',
      price: ['$700', '$3,859', '£2,292', 'A$3450', 'NZ$3420', '$2900', 'CA$5525'],
    },
    {
      name: 'Animator',
      price: ['$650', '$5,688', '£2,917', 'A$4400', 'NZ$3800', '$2600', 'CA$4417'],
    },
    {
      name: 'Project Manager',
      price: ['$900', '$5,894', '£3,891', 'A$3580', 'NZ$3900', '$8400', 'CA$7160'],
    },
    {
      name: 'SMM Specialist',
      price: ['$700', '$3,916', '£2,917', 'A$7500', 'NZ$6208', '$3020', 'CA$4063'],
    },
    {
      name: 'PPC Specialist',
      price: ['$1000', '$3,846', '£3,333', 'A$7604', 'NZ$6042', '$4890', 'CA$6063'],
    },
  ];

  const [showAnimation, setShowAnimation] = useState(false);
  const animateValue = (id, start, end, duration) => {
    if (start === end) return;
    var range = end - start;
    var current = start;
    var increment = end > start ? 1 : -1;
    var stepTime = Math.abs(Math.floor(duration / range));
    var obj = document.getElementById(id);
    var timer = setInterval(function () {
      current += increment;
      obj.innerHTML = current;
      if (current == end) {
        clearInterval(timer);
      }
    }, stepTime);
  };

  const handleClickScroll = () => {
    const element = document.getElementById('page-start');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    formTotalPrice();
  }, [props.currency]);
  const formTotalPrice = () => {
    const c = props.currency.toString();
    if (c == 'amd' || c == 'AMD') {
      setCountryInfo({
        country: 'ARMENIA',
        key: 0,
      });
    }
    if (c == 'eur' || c == 'usd') {
      setCountryInfo({
        country: 'US',
        key: 1,
      });
    }
    if (c == 'gbp') {
      setCountryInfo({
        country: 'UK',
        key: 2,
      });
    }
    if (c == 'aud' || c == 'AUD') {
      setCountryInfo({
        country: 'Australia',
        key: 3,
      });
    }
    if (c == 'cad') {
      setCountryInfo({
        country: 'Canada',
        key: 6,
      });
    }
    if (c == 'nzd') {
      setCountryInfo({
        country: 'New Zealand',
        key: 4,
      });
    }
    if (c == 'sgd') {
      setCountryInfo({
        country: 'Singapore',
        key: 5,
      });
    }
  };

  const settings = {
    infinite: false,
    speed: 400,
    slidesToShow: 3,
    autoplay: false,
    arrows: false,
    dots: false,
    swipe: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          swipe: true,
          dots: true,
          dotsClass: 'custom-dots',
        },
      },
    ],
    afterChange: function (a, b) {},
  };
  const inputEl = useRef(null);
  useEffect(() => {
    document.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      const scrollTop = inputEl.current.offsetTop;

      if (scrollY + 400 >= scrollTop) {
        setShowAnimation(true);
      }
    });
    forceCheck();
  }, []);
  useEffect(() => {
    if (showAnimation) {
      animateValue('block_1', 1, 85, 600);
      animateValue('block_2', 200, 110, 500);
      animateValue('block_3', 0, 64, 900);
      animateValue('block_4', 0, 43, 900);
      animateValue('block_5', 0, 14, 900);
      animateValue('block_6', 0, 45, 1000);
      animateValue('block_7', 0, 67, 990);
      animateValue('block_8', 0, 78, 600);
      animateValue('block_9', -15, 1, 500);
      animateValue('block_10', -5, 128, 600);
    }
  }, [showAnimation]);
  return (
    <>
      <Head>
        <title>Global Sourcing | Production | Digital Marketing - WeProdigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/location" />
        <meta
          name="description"
          content="WeProdigi's global outsourcing for cost-effective video production, design and digital marketing services. Learn more about our location-independent solutions."
        />
        <meta property="og:url" content="https://weprodigi.com/location" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Global Sourcing | Production | Digital Marketing - WeProdigi" />
        <meta
          property="og:description"
          content="WeProdigi's global outsourcing for cost-effective video production, design and digital marketing services. Learn more about our location-independent solutions."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/location/meta.jpg" />
      </Head>
      <style global jsx>{`
        .custom-dots {
          display: flex !important;
          justify-content: center;
          margin-top: 30px;
        }
        .custom-dots li {
          position: relative;
          margin: 0 3px;
          width: 10px;
          height: 10px;
          background-color: #c4c4c4;
          overflow: hidden;
          border-radius: 50%;
        }
        .custom-dots li.slick-active {
          background-color: #670f7a;
        }
        .custom-dots li button {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          opacity: 0;
          //display:none;
        }
        .container-description {
          width: 100%;
          height: auto;
          display: flex;
          flex-wrap: wrap;
          position: relative;
        }

        .container-description > div {
          height: 156px;
          width: 20%;
          //display: flex;
          //justify-content: center;
          //align-items: center;
        }

        .container-description .border-element:nth-child(1),
        .container-description .border-element:nth-child(2),
        .container-description .border-element:nth-child(3),
        .container-description .border-element:nth-child(4) {
          //border-bottom: 0.5px solid #D8D8D8;
          //border-right: 0.5px solid #D8D8D8;
          border-left: 0.5px solid #d8d8d8;
        }

        .container-description .border-element:nth-child(1),
        .container-description .border-element:nth-child(6) {
          border-left: unset !important;
        }

        .container-description .border-element:nth-child(5) {
          //border-bottom: 0.5px solid #D8D8D8;
          border-left: 0.5px solid #d8d8d8;
        }

        .border-element:first-child:before {
          content: '';
          position: absolute;
          width: 80px;
          bottom: -0.5px;
          left: -80px;
          border-bottom: 0.5px solid #d8d8d8;
        }

        .border-element:nth-child(5):before {
          content: '';
          position: absolute;
          width: 80px;
          bottom: -0.5px;
          right: -80px;
          border-bottom: 0.5px solid #d8d8d8;
        }

        .container-description .border-element:nth-child(10) {
          border-top: 0.5px solid #d8d8d8;
          border-left: 0.5px solid #d8d8d8;
        }

        .container-description .border-element:nth-child(6),
        .container-description .border-element:nth-child(7),
        .container-description .border-element:nth-child(8),
        .container-description .border-element:nth-child(9) {
          border-top: 0.5px solid #d8d8d8;
          //border-right: 0.5px solid #D8D8D8;
          border-left: 0.5px solid #d8d8d8;
        }

        .dot-mobile {
          position: relative;
        }

        .dot-desktop {
          position: relative;
        }

        .dot-desktop:after {
          content: '' !important;
          width: 10px;
          height: 10px;
          background: #d8d8d8;
          position: absolute;
          bottom: -5px;
          right: -6px;
          border-radius: 50%;
        }

        .dot-mobile:after {
          content: unset;
          width: 10px;
          height: 10px;
          background: #d8d8d8;
          position: absolute;
          bottom: -5px;
          right: -6px;
          border-radius: 50%;
        }
        @media screen and (max-width: 1300px) {
          #prev,
          #next {
            display: none !important;
          }
        }
        @media screen and (max-width: 900px) {
          .for_mask,
          .for-image {
            // position:relative;
            right: unset;
          }
          .mobile-center {
            justify-content: center;
            alighn-items: center;
          }
          .container-description > div {
            width: 50%;
          }
          .ml-200 {
            margin-left: 0px;
            padding: 0 20px;
          }
          .dot-desktop:after {
            content: unset !important;
          }

          .dot-mobile:after {
            content: '' !important;
          }

          .container-description .border-element:nth-child(2n) {
            border-right: unset;
            border-top: 0.5px solid #d8d8d8;
            border-bottom: 0.5px solid #d8d8d8;
          }

          .container-description .border-element:nth-child(2n + 1) {
            border-left: unset;
            border-top: 0.5px solid #d8d8d8 !important;
            border-bottom: 0.5px solid #d8d8d8;
          }

          .container-description .border-element:nth-child(5) {
            border-right: 0px solid #d8d8d8;
          }

          .container-description .border-element:nth-child(6) {
            border-left: 0.5px solid #d8d8d8 !important;
            border-left: 0.5px solid #d8d8d8 !important;
          }

          .container-description .border-element:nth-child(10),
          .container-description .border-element:nth-child(9) {
            border-bottom: unset;
          }

          .container-description .border-element:nth-child(1),
          .container-description .border-element:nth-child(2) {
            border-top: unset !important;
          }
        }

        .for_mask {
          -webkit-mask-image: url(/images/about/trophy1mask.png);
          mask-image: url(/images/about/trophy1mask.png);
          mask-repeat: no-repeat;
          mask-position: center;
        }

        #stars,
        #stars1,
        #stars2 {
          position: absolute;
        }
      `}</style>
      <div className={`relative w-full  h-intro  overflow-hidden `}>
        <div className={st['header-img-scale-container'] + ' animation'}>
          <img src="https://weprodigi.com/uploads/images/location/location_main.jpg" className={'hidden md:block'} alt="location_main" />
          <img src="https://weprodigi.com/uploads/images/location/header-mobile.jpg" className={'block md:hidden'} alt="header-mobile" />
        </div>
        <div className="container h-full">
          <h1 className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <div className="capitalize text-white text-30 md:text-60  font-bolder leading-none max-w-800">you don’t need</div>
            <div className="capitalize text-white text-30 md:text-60  font-bolder leading-none max-w-800 mt-20">to pay for location</div>
            <div className={'cursor-pointer icon-green mt-23 md:mt-0'} />
          </h1>
        </div>
        <div onClick={handleClickScroll} className="cursor-pointer scroll-button flex absolute bottom-20 justify-center w-full">
          <div className={st.mouse_scroll}>
            <div>
              <span className={st.m_scroll_arrows + ' ' + st.unu} />
              <span className={st.m_scroll_arrows + ' ' + st.doi} />
              <span className={st.m_scroll_arrows + ' ' + st.trei} />
            </div>
          </div>
        </div>
      </div>
      {/*<LazyLoad height={200}  once>*/}
      <div id={'page-start'} className={'bg-white py-24'}>
        <div className="container">
          <div className={' pl-0 md:pl-20  block md:flex justify-between flex-row md:flex-row-reverse'}>
            <div className={'mt-20 w-half-auto hidden md:block'}>
              <ViewMore ln={100}>
                In an era where globalization and internet connectivity have made physical borders less relevant, businesses are increasingly
                operating in the digital domain. For instance, a New York company can seamlessly work with local partners, often without the need for
                offline meetings. The traditional concept of in-house agencies is fading, as collaborations with offshore agencies grow, undeterred by
                geographical distances. Processes previously associated with high resource usage and time expenditure are now becoming streamlined,
                enabling businesses to channel their focus towards their objectives. Embracing these global shifts, Prodigi has pioneered
                communication processes that are reliable, agile, and swift, placing greater emphasis on expertise and knowledge rather than
                geographical location. At Prodigi, we prioritize a smooth partner experience. We offer an absolute cultural alignment, assuaging fears
                around outsourcing and effectively bridging language barriers with our diverse, multilingual team. Our flexible operation model
                accommodates varied time zones, ensuring our services are available when needed. This approach is continually validated by the
                experiences of our loyal clientele.
              </ViewMore>
            </div>
            <div className={'mt-20 block md:hidden'}>
              <ViewMore ln={40}>
                In an era where globalization and internet connectivity have made physical borders less relevant, businesses are increasingly
                operating in the digital domain. For instance, a New York company can seamlessly work with local partners, often without the need for
                offline meetings. The traditional concept of in-house agencies is fading, as collaborations with offshore agencies grow, undeterred by
                geographical distances. Processes previously associated with high resource usage and time expenditure are now becoming streamlined,
                enabling businesses to channel their focus towards their objectives. Embracing these global shifts, Prodigi has pioneered
                communication processes that are reliable, agile, and swift, placing greater emphasis on expertise and knowledge rather than
                geographical location. At Prodigi, we prioritize a smooth partner experience. We offer an absolute cultural alignment, assuaging fears
                around outsourcing and effectively bridging language barriers with our diverse, multilingual team. Our flexible operation model
                accommodates varied time zones, ensuring our services are available when needed. This approach is continually validated by the
                experiences of our loyal clientele.{' '}
              </ViewMore>
            </div>
            <div className="pb-10 w-full md:w-half-auto block  mt-23 mb-10">
              <video controls poster={'https://weprodigi.com/uploads/images/location/thumbnail.png'}>
                <source src="https://weprodigi.com/uploads/images/location/Location-Checklist-for-your-Video-Vendor.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
          <br className={'clear-both hidden'} />
        </div>
      </div>
      {/*</LazyLoad>*/}

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className="title font-bolder text-24 md:text-48 text-black uppercase leading-1">monthly salary rates </h2>
            <div className="flex md:hidden gap-12 items-center justify-center mt-15 mb-15">
              <button
                onClick={() => setActiveTab(0)}
                className={'w-119 h-39 text-18 leading-22 font-400 px-20 py-8 rounded-5 ' + (activeTab == 0 ? st.activeTab : st.noActive)}
              >
                {countryInfo.country}
              </button>
              <button
                onClick={() => setActiveTab(1)}
                className={'w-119 h-39 text-18 leading-22 font-400 px-20 py-8 rounded-5 ' + (activeTab == 1 ? st.activeTab : st.noActive)}
              >
                Armenia
              </button>
            </div>
            <div className="relative overflow-x-auto">
              <div className="hidden md:flex justify-between ">
                <div className="w-60p md:w-80p font-normal text-gray-headerIcon text-18 text-center py-3 uppercase" />
                <div
                  className={
                    'w-20p font-normal text-gray-headerIcon text-18 text-center py-3 uppercase ' +
                    (activeTab == 0 ? 'block md:block' : 'hidden md:block')
                  }
                >
                  {countryInfo.country}
                </div>
                <div
                  className={
                    'w-20p font-normal text-gray-headerIcon text-18 text-center py-3 uppercase ' +
                    (activeTab == 1 ? 'block md:block' : 'hidden md:block')
                  }
                >
                  Armenia
                </div>
              </div>

              <div className="bg-red-smmSlideTwo rounded-10 flex items-center h-56 mt-7">
                <div className="w-60p md:w-80p  px-10 md:px-50 text-left font-normal text-gray-headerIcon text-16 md:text-24  py-3 ">
                  Motion Graphic Designer
                </div>
                <div
                  className={
                    'w-40p md:w-20p font-bolder text-purple text-16 md:text-24 text-right md:text-center py-3 uppercase pr-10 md:pr-0 ' +
                    (activeTab == 0 ? 'block md:block' : 'hidden md:block')
                  }
                >
                  {positions[0].price[countryInfo.key]}
                </div>
                <div
                  className={
                    'w-40p md:w-20p font-bolder text-purple text-16 md:text-24 text-right md:text-center py-3 uppercase pr-10 md:pr-0 ' +
                    (activeTab == 1 ? 'block md:block' : 'hidden md:block')
                  }
                >
                  {positions[0].price[0]}
                </div>
              </div>
              <div className="bg-purple-table rounded-10 flex items-center h-56 mt-7">
                <div className="px-10 md:px-50  w-60p md:w-80p  font-normal text-gray-headerIcon text-16 md:text-24   py-3 ">Graphic Designer</div>
                <div
                  className={
                    'w-40p md:w-20p font-bolder text-purple text-16 md:text-24 text-right md:text-center py-3 uppercase pr-10 md:pr-0 ' +
                    (activeTab == 0 ? 'block md:block' : 'hidden md:block')
                  }
                >
                  {positions[1].price[countryInfo.key]}
                </div>
                <div
                  className={
                    'w-40p md:w-20p font-bolder text-purple text-16 md:text-24 text-right md:text-center py-3 uppercase pr-10 md:pr-0 ' +
                    (activeTab == 1 ? 'block md:block' : 'hidden md:block')
                  }
                >
                  {positions[1].price[0]}
                </div>
              </div>
              <div className="bg-red-smmSlideTwo rounded-10 flex items-center h-56 mt-7">
                <div className="px-10 md:px-50 text-left w-60p md:w-80p  font-normal text-gray-headerIcon text-16 md:text-24  py-3 ">Animator</div>
                <div
                  className={
                    'w-40p md:w-20p  font-bolder text-purple text-16 md:text-24 text-right md:text-center py-3 uppercase pr-10 md:pr-0 ' +
                    (activeTab == 0 ? 'block md:block' : 'hidden md:block')
                  }
                >
                  {positions[2].price[countryInfo.key]}
                </div>
                <div
                  className={
                    'w-40p md:w-20p font-bolder text-purple text-16 md:text-24 text-right md:text-center py-3 uppercase pr-10 md:pr-0 ' +
                    (activeTab == 1 ? 'block md:block' : 'hidden md:block')
                  }
                >
                  {positions[2].price[0]}
                </div>
              </div>
              <div className="bg-purple-table rounded-10 flex items-center h-56 mt-7">
                <div className="px-10 md:px-50  w-60p md:w-80p  font-normal text-gray-headerIcon text-16 md:text-24   py-3 ">Project Manager</div>
                <div
                  className={
                    'w-40p md:w-20p font-bolder text-purple text-16 md:text-24 text-right md:text-center py-3 uppercase pr-10 md:pr-0 ' +
                    (activeTab == 0 ? 'block md:block' : 'hidden md:block')
                  }
                >
                  {positions[3].price[countryInfo.key]}
                </div>
                <div
                  className={
                    'w-40p md:w-20p font-bolder text-purple text-16 md:text-24 text-right md:text-center py-3 uppercase pr-10 md:pr-0 ' +
                    (activeTab == 1 ? 'block md:block' : 'hidden md:block')
                  }
                >
                  {positions[3].price[0]}
                </div>
              </div>
              <div className="bg-red-smmSlideTwo rounded-10 flex items-center h-56 mt-7">
                <div className="px-10 md:px-50 text-left w-60p md:w-80p  font-normal text-gray-headerIcon text-16 md:text-24  py-3 ">
                  SMM Specialist
                </div>
                <div
                  className={
                    'w-40p md:w-20p font-bolder text-purple text-16 md:text-24 text-right md:text-center py-3 uppercase pr-10 md:pr-0 ' +
                    (activeTab == 0 ? 'block md:block' : 'hidden md:block')
                  }
                >
                  {positions[4].price[countryInfo.key]}
                </div>
                <div
                  className={
                    'w-40p md:w-20p font-bolder text-purple text-16 md:text-24 text-right md:text-center py-3 uppercase pr-10 md:pr-0 ' +
                    (activeTab == 1 ? 'block md:block' : 'hidden md:block')
                  }
                >
                  {positions[4].price[0]}
                </div>
              </div>
              <div className="bg-purple-table rounded-10 flex items-center h-56 mt-7">
                <div className="px-10 md:px-50  w-60p md:w-80p  font-normal text-gray-headerIcon text-16 md:text-24   py-3 ">PPC Specialist</div>
                <div
                  className={
                    'w-40p md:w-20p font-bolder text-purple text-16 md:text-24 text-right md:text-center py-3 uppercase pr-10 md:pr-0 ' +
                    (activeTab == 0 ? 'block md:block' : 'hidden md:block')
                  }
                >
                  {positions[5].price[countryInfo.key]}
                </div>
                <div
                  className={
                    'w-40p md:w-20p  font-bolder text-purple text-16 md:text-24 text-right md:text-center py-3 uppercase pr-10 md:pr-0 ' +
                    (activeTab == 1 ? 'block md:block' : 'hidden md:block')
                  }
                >
                  {positions[5].price[0]}
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className="title  font-bolder text-24 md:text-48 text-black uppercase leading-1 max-w-600">Global Sourcing. the pros and cons</h2>
            <h3 className="pros text-green uppercase text-18  md:text-36  font-normal-700 ">PROS</h3>
            <div className={'hidden md:block'}>
              <div className="mt-10 md:mt-24 flex justify-between">
                <div className="w-half-auto flex justify-between gap-4 rounded-5 overflow-hidden bg-pink">
                  <img src="https://weprodigi.com/uploads/images/location/pros1.png" className={'object-cover'} width={73} alt="pros1" />
                  <div className={'w-full py-24 pr-24'}>
                    <p className={'text-18 text-purple font-normal-700 max-w-120 leading-19.5'}>Cost reduction</p>
                    <p className={'mt-10 text-16  text-black'}>
                      Marketing services in the digital world are powered by qualified professionals, regardless of their location. Nevertheless, the
                      cost of services can depend on the location of the provider due to different wages and expenses. In high-GDP countries,
                      employees with the same expertise are paid more, and businesses incur higher fixed costs than those with the same qualifications
                      in low-GDP countries. That being said, it's still possible to get the same quality of service for a lesser price without having
                      to break the bank.
                    </p>
                  </div>
                </div>
                <div className="w-half-auto flex justify-between gap-4 rounded-5 overflow-hidden bg-gray-light">
                  <img src="https://weprodigi.com/uploads/images/location/pros2.png" className={'object-cover'} width={73} alt="pros2" />
                  <div className={'w-full py-24 pr-24'}>
                    <p className={'text-18 text-purple font-normal-700 max-w-200 leading-19.5'}>Access to the better talent pool</p>
                    <p className={'mt-10 text-16  text-black'}>
                      A US-based service provider is not always a guarantee of a professional and talented workforce. Offshore outsourcing, however,
                      grants absolute access to skilled labor. This allows for the identification of talents with specific skills and expertise that
                      are not available within the organization. On the other side, global vendors, unbounded by physical borders, partner with
                      organizations from offshore countries, gaining expertise through time and experience and enabling them to better comprehend
                      clients' needs and formulate solutions.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-24 flex justify-between">
                <div className="w-half-auto flex justify-between gap-4 rounded-5 overflow-hidden bg-gray-light">
                  <img src="https://weprodigi.com/uploads/images/location/pros3.png" width={73} className={'object-cover'} alt="pros3" />
                  <div className={'w-full py-24 pr-24'}>
                    <p className={'text-18 text-purple font-normal-700 max-w-120 leading-19.5'}>Process optimization</p>
                    <p className={'mt-10 text-16  text-black'}>
                      Highly-reputable outsourcing agencies working off-shore in different time zones and with different cultures have streamlined
                      processes and solutions in place to save time and enhance the client experience. Such global expertise and reach can lead to
                      increased productivity, high-level flexibility, cost savings, and a hassle-free experience for partners. With outsourcing, you
                      can focus on your core business needs and leave the operational tasks to the experts. Many companies have already discovered the
                      benefits of outsourcing marketing and production services. It's a tried-and-true method that has been utilized by small and
                      medium-sized businesses for years as a viable business strategy.{' '}
                    </p>
                  </div>
                </div>
                <div className="w-half-auto flex justify-between gap-4 rounded-5 overflow-hidden bg-pink">
                  <img src="https://weprodigi.com/uploads/images/location/pros4.png" className={'object-cover'} width={73} alt="pros4" />
                  <div className={'w-full py-24 pr-24'}>
                    <p className={'text-18 text-purple font-normal-700 max-w-300 leading-19.5'}>Access to the best & innovational technologies</p>
                    <p className={'mt-10 text-16  text-black'}>
                      The competitive nature of the global market drives service providers to constantly strive for improvement and seek out new
                      opportunities. While a local agency may only have to compete with other organizations in its immediate area, global agencies
                      must face competition from companies all over the world. This global competition pushes these agencies to develop innovative
                      solutions and deliver top-notch customer service and service quality. Outsourcing to an offshore agency can provide access to
                      resources and creative, innovative, time-efficient, and flexible solutions that may not be available from a local provider.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="block md:hidden mt-20">
              <Slider {...settings} className="process-slider relative z-10">
                <div className={'w-full h-461'}>
                  {' '}
                  <div className="w-full  h-461 flex justify-between gap-4 rounded-5 overflow-x-hidden bg-pink">
                    <img src="https://weprodigi.com/uploads/images/location/pros1.png" className={'object-cover'} width={73} alt="pros1" />
                    <div className={'w-full py-24 pr-24'}>
                      <p className={'text-18 text-purple font-normal-700 max-w-120 leading-19.5'}>Cost reduction</p>
                      <p className={'mt-10 text-14  text-black'}>
                        Marketing services in the digital world are powered by qualified professionals, regardless of their location. Nevertheless,
                        the cost of services can depend on the location of the provider due to different wages and expenses. In high-GDP countries,
                        employees with the same expertise are paid more, and businesses incur higher fixed costs than those with the same
                        qualifications in low-GDP countries. That being said, it's still possible to get the same quality of service for a lesser
                        price without having to break the bank.
                      </p>
                    </div>
                  </div>
                </div>
                <div className={'w-full h-461'}>
                  {' '}
                  <div className="w-full h-461 flex justify-between gap-4 rounded-5 overflow-x-hidden bg-gray-light">
                    <img src="https://weprodigi.com/uploads/images/location/pros2.png" className={'object-cover'} width={73} alt="pros2" />
                    <div className={'w-full py-24 pr-24'}>
                      <p className={'text-18 text-purple font-normal-700 max-w-200 leading-19.5'}>Access to the better talent pool</p>
                      <p className={'mt-10 text-14  text-black'}>
                        A US-based service provider is not always a guarantee of a professional and talented workforce. Offshore outsourcing, however,
                        grants absolute access to skilled labor. This allows for the identification of talents with specific skills and expertise that
                        are not available within the organization. On the other side, global vendors, unbounded by physical borders, partner with
                        organizations from offshore countries, gaining expertise through time and experience and enabling them to better comprehend
                        clients' needs and formulate solutions.
                      </p>
                    </div>
                  </div>
                </div>
                <div className={'w-full h-461'}>
                  {' '}
                  <div className="w-full h-461 flex justify-between gap-4 rounded-5 overflow-x-hidden bg-gray-light">
                    <img src="https://weprodigi.com/uploads/images/location/pros3.png" width={73} className={'object-cover'} alt="pros3" />
                    <div className={'w-full py-24 pr-24'}>
                      <p className={'text-18 text-purple font-normal-700 max-w-120 leading-19.5'}>Process optimization</p>
                      <p className={'mt-10 text-14  text-black'}>
                        Highly-reputable outsourcing agencies working off-shore in different time zones and with different cultures have streamlined
                        processes and solutions in place to save time and enhance the client experience. Such global expertise and reach can lead to
                        increased productivity, high-level flexibility, cost savings, and a hassle-free experience for partners. With outsourcing, you
                        can focus on your core business needs and leave the operational tasks to the experts. Many companies have already discovered
                        the benefits of outsourcing marketing and production services. It's a tried-and-true method that has been utilized by small
                        and medium-sized businesses for years as a viable business strategy.{' '}
                      </p>
                    </div>
                  </div>
                </div>
                <div className={'w-full h-461'}>
                  {' '}
                  <div className="w-full h-461 flex justify-between gap-4 rounded-5 overflow-x-hidden bg-pink">
                    <img src="https://weprodigi.com/uploads/images/location/pros4.png" className={'object-cover'} width={73} alt="pros4" />
                    <div className={'w-full py-24 pr-24'}>
                      <p className={'text-18 text-purple font-normal-700 max-w-300 leading-19.5'}>Access to the best & innovational technologies</p>
                      <p className={'mt-10 text-14  text-black'}>
                        The competitive nature of the global market drives service providers to constantly strive for improvement and seek out new
                        opportunities. While a local agency may only have to compete with other organizations in its immediate area, global agencies
                        must face competition from companies all over the world. This global competition pushes these agencies to develop innovative
                        solutions and deliver top-notch customer service and service quality. Outsourcing to an offshore agency can provide access to
                        resources and creative, innovative, time-efficient, and flexible solutions that may not be available from a local provider.
                      </p>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>

            <h3 className="pros text-green uppercase text-18  md:text-36 font-normal-700 mt-10 md:mt-24">CONS</h3>
            <div className="hidden md:flex gap-2">
              <div className="bg-gray-slideOne py-32 px-20 rounded-5 w-33p ">
                <div className={'flex gap-1 w-full justify-between items-start mb-10'}>
                  <p className={'text-purple font-normal-700 text-24 max-w-300'}>Less Control, Security & Quality Issues</p>
                  <img src="https://weprodigi.com/uploads/images/location/Vector.svg" width={25} alt="Vector" />
                </div>
                <ViewMore ln={40}>
                  One common concern about outsourcing is the perceived loss of control and the potential for reduced quality of service. Small and
                  medium-sized businesses (SMBs) often have a more centralized system due to their smaller size. However, outsourcing does not
                  necessarily mean giving up all control. It simply means trusting an external provider to handle important operational functions.
                  While it may be challenging to maintain control from a distance, it is still possible to establish clear communication channels and
                  set expectations for service quality. It's also significant to carefully vet potential outsourcing partners and ensure they are
                  trustworthy and capable of meeting your needs.
                </ViewMore>
                <p className="mt-10 text-16 text-green font-medium mb-10">How we handle this:</p>

                <ViewMore ln={30}>
                  We have implemented an online action plan that allows you to monitor the status of your projects in real-time. This ensures that you
                  have visibility into the progress of your work and can stay up-to-date on the status of your projects. To give you confidence in our
                  services, you can view our portfolio and read reviews from previous clients. We are committed to delivering high-quality results and
                  strive to exceed our client's expectations. In addition, we offer a risk-free cooperation model. You only pay for our services after
                  the work has begun, so you don't have to worry about putting your time and money at risk.
                </ViewMore>
              </div>
              <div className="bg-white py-32 px-20 rounded-5 w-33p">
                <div className={'flex gap-1 w-full justify-between items-start mb-10'}>
                  <p className={'text-purple font-normal-700 text-24 max-w-300'}>
                    Communication <br /> Issues{' '}
                  </p>
                  <img src="https://weprodigi.com/uploads/images/location/cons2.svg" width={25} alt="cons2" />
                </div>
                <ViewMore ln={35}>
                  Communication can be a challenge in global outsourcing arrangements due to the geographical distance between the service provider
                  and the client. Other factors that can contribute to communication issues include time zone differences, language barriers, and
                  cultural differences. To overcome these challenges, it is important to establish clear and open communication channels from the
                  outset of the outsourcing relationship. This may involve using tools such as video conferencing, online project management
                  platforms, and translators to facilitate communication.
                </ViewMore>
                <p className="mt-10 text-16 text-green font-medium mb-10">How we handle this:</p>

                <ViewMore ln={30}>
                  Globalization has made it possible to work with clients and partners located all over the world, regardless of language and cultural
                  differences. At our company, we have successfully served clients from various locations and have overcome any communication
                  challenges that may have arisen. To learn more about how we have managed communication in our global outsourcing partnerships, we
                  invite you to watch our video showcasing client experiences.
                </ViewMore>
              </div>
              <div className="bg-gray-slideOne py-32 px-20 rounded-5 w-33p  ">
                <div className={'flex gap-1 w-full justify-between items-start mb-10'}>
                  <p className={'text-purple font-normal-700 text-24 max-w-300'}>Difficult to Find The Right Partner</p>
                  <img src="https://weprodigi.com/uploads/images/location/cons3.svg" width={25} alt="cons3" />
                </div>
                <ViewMore ln={40}>
                  Finding the right outsourcing partner can be challenging, especially if you are unfamiliar with the field. Challenges don’t get
                  easier in the tremendously fast-developing digital world, where every second newborn agency proclaims itself an expert in digital
                  marketing and production and clutters up the internet with screaming ads about their expertise. How to not fall for this trick and
                  not fail? It is important to take the time to carefully research and evaluate potential partners to ensure that they are a good fit
                  for your business needs.
                </ViewMore>
                <p className="mt-10 text-16 text-green font-medium mb-10">How we handle this:</p>

                <ViewMore ln={20}>
                  We have created a checklist to help our partners in their research phase. The checklist includes all the critical points to reveal
                  business needs and expectations, challenges, and solutions for a productive partnership in digital marketing and production.
                </ViewMore>
              </div>
            </div>
            <div className="block md:hidden mt-20">
              <Slider {...settings} className="process-slider relative z-10">
                <div className="bg-gray-slideOne py-32 px-20 rounded-5 w-33p ">
                  <div className={'flex gap-1 w-full justify-between items-start mb-10'}>
                    <p className={'text-purple font-normal-700 text-24 max-w-300'}>Less Control, Security & Quality Issues</p>
                    <img src="https://weprodigi.com/uploads/images/location/Vector.svg" width={25} alt="Vector" />
                  </div>
                  <ViewMore ln={40}>
                    One common concern about outsourcing is the perceived loss of control and the potential for reduced quality of service. Small and
                    medium-sized businesses (SMBs) often have a more centralized system due to their smaller size. However, outsourcing does not
                    necessarily mean giving up all control. It simply means trusting an external provider to handle important operational functions.
                    While it may be challenging to maintain control from a distance, it is still possible to establish clear communication channels
                    and set expectations for service quality. It's also significant to carefully vet potential outsourcing partners and ensure they
                    are trustworthy and capable of meeting your needs.
                  </ViewMore>
                  <p className="mt-10 text-16 text-green font-medium mb-10">How we handle this:</p>

                  <ViewMore ln={30}>
                    We have implemented an online action plan that allows you to monitor the status of your projects in real-time. This ensures that
                    you have visibility into the progress of your work and can stay up-to-date on the status of your projects. To give you confidence
                    in our services, you can view our portfolio and read reviews from previous clients. We are committed to delivering high-quality
                    results and strive to exceed our client's expectations. In addition, we offer a risk-free cooperation model. You only pay for our
                    services after the work has begun, so you don't have to worry about putting your time and money at risk.
                  </ViewMore>
                </div>
                <div className="bg-white py-32 px-20 rounded-5 w-33p">
                  <div className={'flex gap-1 w-full justify-between items-start mb-10'}>
                    <p className={'text-purple font-normal-700 text-24 max-w-300'}>
                      Communication <br /> Issues{' '}
                    </p>
                    <img src="https://weprodigi.com/uploads/images/location/cons2.svg" width={25} alt="cons2" />
                  </div>
                  <ViewMore ln={35}>
                    Communication can be a challenge in global outsourcing arrangements due to the geographical distance between the service provider
                    and the client. Other factors that can contribute to communication issues include time zone differences, language barriers, and
                    cultural differences. To overcome these challenges, it is important to establish clear and open communication channels from the
                    outset of the outsourcing relationship. This may involve using tools such as video conferencing, online project management
                    platforms, and translators to facilitate communication.
                  </ViewMore>
                  <p className="mt-10 text-16 text-green font-medium mb-10">How we handle this:</p>

                  <ViewMore ln={30}>
                    Globalization has made it possible to work with clients and partners located all over the world, regardless of language and
                    cultural differences. At our company, we have successfully served clients from various locations and have overcome any
                    communication challenges that may have arisen. To learn more about how we have managed communication in our global outsourcing
                    partnerships, we invite you to watch our video showcasing client experiences.
                  </ViewMore>
                </div>
                <div className="bg-gray-slideOne py-32 px-20 rounded-5 w-33p  ">
                  <div className={'flex gap-1 w-full justify-between items-start mb-10'}>
                    <p className={'text-purple font-normal-700 text-24 max-w-300'}>Less Control, Security & Quality Issues</p>
                    <img src="https://weprodigi.com/uploads/images/location/cons3.svg" width={25} alt="cons3" />
                  </div>
                  <ViewMore ln={40}>
                    Finding the right outsourcing partner can be challenging, especially if you are unfamiliar with the field. Challenges don’t get
                    easier in the tremendously fast-developing digital world, where every second newborn agency proclaims itself an expert in digital
                    marketing and production and clutters up the internet with screaming ads about their expertise. How to not fall for this trick and
                    not fail? It is important to take the time to carefully research and evaluate potential partners to ensure that they are a good
                    fit for your business needs.
                  </ViewMore>
                  <p className="mt-10 text-16 text-green font-medium mb-10">How we handle this:</p>

                  <ViewMore ln={20}>
                    We have created a checklist to help our partners in their research phase. The checklist includes all the critical points to reveal
                    business needs and expectations, challenges, and solutions for a productive partnership in digital marketing and production.
                  </ViewMore>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </LazyLoad>
      <div className="bg-gray-light" ref={inputEl}>
        <div className="container">
          <div className="flex flex-wrap py-30 justify-between">
            <h2 className="title  font-bolder text-24 md:text-48 text-black uppercase leading-1">Global Sourcing Statistics</h2>

            <div className="container-description mt-30">
              <div className="border-element dot-mobile dot-desktop">
                <div className="ml-10 md:ml-0 text-green  text-25 md:text-36 leading-44 font-black">
                  <span className="number" id="block_1">
                    85
                  </span>
                  %
                </div>
                <div className="ml-10 md:ml-0 font-normal text-14 md:text-16 leading-20  mt-5 md:mt-15 w-90p">
                  of labor costs can be reduced by outsourcing{' '}
                </div>
              </div>
              <div className="border-element dot-desktop ">
                <div className="text-green text-25 md:text-36 leading-44 font-black px-10 md:px-30 whitespace-nowrap">
                  $
                  <span className="number" id="block_2">
                    110
                  </span>
                  .5 b.
                </div>
                <div className="font-normal text-14 md:text-16 leading-20 px-10 md:px-30 mt-5 md:mt-15 ">
                  is the worth of the global outsourcing market in 2022
                </div>
              </div>
              <div className="border-element dot-mobile dot-desktop">
                <div className="text-green text-25 md:text-36 leading-44 font-black px-10 md:px-30 whitespace-nowrap">
                  <span className="number" id="block_3">
                    64
                  </span>
                  %
                </div>
                <div className="font-normal text-14 md:text-16 leading-20 px-10 md:px-30 mt-5 md:mt-15 ">
                  of companies outsource globally to cut costs{' '}
                </div>
              </div>
              <div className="border-element dot-desktop">
                <div className="text-green text-25 md:text-36 leading-44 font-black px-10 md:px-30">
                  <span className="number" id="block_4">
                    43
                  </span>
                  %
                </div>
                <div className="font-normal text-14 md:text-16 leading-20 px-10 md:px-30 mt-5 md:mt-15 ">
                  of small businesses outsource globally at least part of their business process
                </div>
              </div>
              <div className="border-element dot-mobile">
                <div className="text-green text-25 md:text-36 leading-44 font-black px-10 md:px-30">
                  <span className="" id="block_5">
                    14
                  </span>
                  .3mln
                </div>
                <div className="font-normal text-14 md:text-16 leading-20 px-10 md:px-30 mt-5 md:mt-15 ">
                  jobs are outsourced globally from the US{' '}
                </div>
              </div>

              <div className="border-element ">
                <div className="ml-10 md:ml-0 text-green text-25 md:text-36 leading-44 font-black">
                  <span className="number" id="block_6">
                    45
                  </span>
                  %
                </div>
                <div className="ml-10 md:ml-0 font-normal text-14 md:text-16 leading-20  mt-5 md:mt-15 w-90p ">
                  of global corporations planned to increase outsourcing worldwide due to the pandemic
                </div>
              </div>
              <div className="border-element dot-mobile">
                <div className="text-green text-25 md:text-36 leading-44 font-black px-10 md:px-30">
                  <span className="number" id="block_7">
                    67
                  </span>
                  %
                </div>
                <div className="font-normal text-14 md:text-16 leading-20 px-10 md:px-30 mt-5 md:mt-15 ">
                  of the UK’s start-ups outsource their workforce globally{' '}
                </div>
              </div>
              <div className="border-element ">
                <div className="text-green text-25 md:text-36 leading-44 font-black px-10 md:px-30">
                  <span className="number" id="block_8">
                    78
                  </span>
                  %
                </div>
                <div className="font-normal text-14 md:text-16 leading-20 px-10 md:px-30 mt-5 md:mt-15 ">
                  of Businesses Have a Positive Relationship with their global partners
                </div>
              </div>
              <div className="border-element ">
                <div className="text-green text-25 md:text-36 leading-44 font-black px-10 md:px-30">
                  <span className="number" id="block_9">
                    1
                  </span>
                  <span className={'text-23 md:text-30'}>in</span>3
                </div>
                <div className="font-normal text-14 md:text-16 leading-20 px-10 md:px-30 mt-5 md:mt-15 ">
                  Over 1 in 3 small businesses outsource some of their work
                </div>
              </div>
              <div className="border-element">
                <div className="text-green text-25 md:text-36 leading-44 font-black px-10 md:px-30">
                  <span className="number" id="block_10">
                    128
                  </span>
                  %
                </div>
                <div className="font-normal text-14 md:text-16 leading-20 px-10 md:px-30 mt-5 md:mt-15 ">
                  128% - Large businesses are 128% more willing to outsource work than small businesses.
                </div>
              </div>
            </div>
          </div>

          <div className="flex pb-24 gap-4 items-center">
            <div className="text-16 text-purple">Sources:</div>
            <a href="https://www.statista.com/statistics/189788/global-outsourcing-market-size/" target={'_blank'}>
              <img src="https://weprodigi.com/uploads/images/location/statista.svg" alt="statista" />
            </a>
            <a href="https://www2.deloitte.com/cy/en/pages/tax/articles/outsourcing_relevancy_post_covid19_environment.html" target={'_blank'}>
              <img src="https://weprodigi.com/uploads/images/location/deloit.svg" alt="deloit" />
            </a>
            <a href="https://clutch.co/bpo/virtual-assistants/resources/small-business-outsourcing-statistics" target={'_blank'}>
              <img src="https://weprodigi.com/uploads/images/location/cloutch.svg" alt="cloutch" />
            </a>
            <a href="https://www.forbes.com/?sh=6b62d1eb2254" target={'_blank'}>
              <img src="https://weprodigi.com/uploads/images/location/forbes.svg" alt="forbes" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationLanding;
